import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Button, Dropdown, Form, Container, Row, Col } from "react-bootstrap";
import Slider from '../components/Slider';
import NewNav from '../components/NewNav';
import Footer from '../components/Footer';
import config from "../config.js";
import SpecificationTable from '../components/SpecificationTable.jsx';
import Swal from "sweetalert2";

function Cart() {
  const [quantity, setQuantity] = useState(1);
  const [colorTemp, setColorTemp] = useState("Select Color Temperature");
  const [capType, setCapType] = useState("Select Cap Type");
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [description, setDescription] = useState("");

  useEffect(() => {
    axios
      .get(`${config.API_BASE_URL}/api/specificationdata/${id}`)
      .then((response) => {
        if (response.data.length > 0) {
          setProduct(response.data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching product:", error);
      });
  }, [id]);

  const isValidSelection = () => {
    if (colorTemp === "Select Color Temperature") return false;
    if (product?.category_id === 2 && capType === "Select Cap Type") return false;
    return true;
  };

  const addToCart = () => {
    if (!isValidSelection()) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Selection",
        text: "Please select color temperature and cap type (if required).",
      });
      return;
    }

    const cartItem = {
      product_id: id,
      quantity,
      specifications_type: colorTemp,
      cap_type: capType,
      description,
    };

    axios
      .post(`${config.API_BASE_URL}/api/add-to-cart`, cartItem)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Added to cart successfully!",
            confirmButtonText: "OK",
          }).then(() => {
           window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Error during checkout.",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Something went wrong. Please try again later.",
        });
      });
  };

  if (!product) return <p>Loading...</p>;

  return (
    <div className='cart-page-wrapper'>
      <NewNav />
      <Container className="product-container mb-5">
        <Row className=''>
          <Col md={4} className="product-image">
            <img className="product-image" src={product.image} alt={product.product_model} />
          </Col>
          <Col md={8} className="product-details">
            <h2>{product.product_model}</h2>
            <div className='varienty-wraper'>
              <p>1 Year Warranty</p>
              <a href="/contact" className="bulk-order">Bulk Order</a>
            </div>
            <h5>Price: Rs <span>{product.price}</span></h5>

            {/* Color Temperature Dropdown */}
            <Dropdown className="cart-dropdown mb-2">
              <Dropdown.Toggle variant="light" className="cart-dropdown-toggle">
                {colorTemp}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setColorTemp("Warm White")}>Warm White</Dropdown.Item>
                <Dropdown.Item onClick={() => setColorTemp("Cool White")}>Cool White</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Cap Type Dropdown (only if category_id === 2) */}
            {product.category_id === 2 && (
              <Dropdown className="cart-dropdown mb-2">
                <Dropdown.Toggle variant="light" className="cart-dropdown-toggle">
                  {capType}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setCapType("E27")}>E27</Dropdown.Item>
                  <Dropdown.Item onClick={() => setCapType("B22")}>B22</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}

            <Form.Control
              as="textarea"
              rows={2}
              placeholder="Add description or notes"
              className="description mb-3"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <div className="quantity-container mt-3 mb-3 d-flex align-items-center">
              <Button
                variant="light"
                className="quantity-btn"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                -
              </Button>
              <span className="quantity mx-2">{quantity}</span>
              <Button
                variant="light"
                className="quantity-btn"
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </Button>
            </div>

            <Button
              variant="primary"
              className="openButton add-to-cart"
              onClick={addToCart}
              disabled={!isValidSelection()}
            >
              Add to Cart
            </Button>

            <div className="mt-4">
              <SpecificationTable />
            </div>
          </Col>
        </Row>
      </Container>
      <Slider />
      <Footer />
    </div>
  );
}

export default Cart;
